import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { mcpGatewaysQueryOptions } from "@/app/mcp-gateways/api/get-mcp-gateways";
import { MCPGatewaysListSkeleton } from "@/app/mcp-gateways/components/mcp-gateways-list-skeleton";
import { MCPGatewayList } from "@/app/mcp-gateways/list";
import {
  mcpGatewaysSearchDefaults,
  mcpGatewaysSearchSchema,
} from "@/app/mcp-gateways/search-params";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways/"
)({
  validateSearch: mcpGatewaysSearchSchema,
  search: {
    middlewares: [stripSearchParams(mcpGatewaysSearchDefaults)],
  },
  component: () => (
    <Suspense fallback={<MCPGatewaysListSkeleton />}>
      <MCPGatewayList />
    </Suspense>
  ),
  // The parent `mcp-gateways` layout route already read-gates this subtree, so
  // no permission check is repeated here.
  beforeLoad(ctx) {
    ctx.context.queryClient.prefetchQuery(
      mcpGatewaysQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
});
